<template>
  <div>
    <h3>In order to authorize BudgetVals app to access Xero account data</h3>
    <button type="button" class="btn-success" @click="connectXero()">
      Connect to Xero Account
    </button>
  </div>
</template>

<script>
import {
  OPEN_ERROR_MODAL
} from '@/vuex/types'
import Api from '@/vuex/api'
export default {
  name: 'XeroSetting',
  methods: {
    async connectXero () {
      try {
        let instance = new Api()
        let xeroLoginUrl = await instance.connectXero()
        // Open Xero Login page in a new tab
        window.open(xeroLoginUrl)
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/XeroSetting.vue